import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import { KeyValueDefault } from "@/main/models/common";
import { KeyValueDefaultEnum } from "@/main/models/common/keyValueDefaultEnum";
import { CountryPublicResponse } from "@/main/models/response";
import { CountryByVehicleFilterRequest } from "@/main/models/request";

export abstract class ICountryApi {
	abstract getDomain(idUser: string | null): Promise<AxiosResponse<Result<KeyValueDefault[]>>>;
	abstract getPublicDomain(): Promise<AxiosResponse<Result<CountryPublicResponse[]>>>;
	abstract getDomainByVehicles(
		filter?: CountryByVehicleFilterRequest,
	): Promise<AxiosResponse<Result<KeyValueDefaultEnum[]>>>;
}
